export type { EventService } from './event.service'
export { EventModule } from './event.module'
